import {GET_VEHICLE_LOGS_SUCCESS} from "../../reducers/vehicleReducer";


export const getVehicleLogsSuccess = (logs) =>{
    return {
        type: GET_VEHICLE_LOGS_SUCCESS,
        payload: {logs}
    }
}